import React from 'react';
import { Typography } from '@material-ui/core';

import Box from '@material-ui/core/Box';
import { APP_PRIMARY } from 'colours';
import { dnaStep4 } from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';

function DnaKitInstructionsStep4(props) {
  const { t } = useTranslation();
  return (
    <div>
      <Box px={{ xs: 2, sm: 3, md: 4 }} justifyContent="center" display="flex">
        <Typography variant="h5" style={{ color: APP_PRIMARY }}>
          {t(
            'onboarding.dnaKitInstructionsSection.dnaKitInstructionsStep4.heading'
          )}
        </Typography>
      </Box>

      <Box px={{ xs: 2, sm: 3, md: 4 }} justifyContent="center" display="flex">
        <img src={dnaStep4} alt="illustration" />
      </Box>

      <Box p={{ xs: 2, sm: 3, md: 4 }} justifyContent="center" display="flex">
        <Typography variant="body1" style={{ fontSize: 14 }}>
          {t(
            'onboarding.dnaKitInstructionsSection.dnaKitInstructionsStep4.textBody1'
          )}
        </Typography>
      </Box>
    </div>
  );
}

export default DnaKitInstructionsStep4;
